import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

import { UtilService } from '@app/service/util.service';
import { config } from '@app/service/config.service';

import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-board-list',
  templateUrl: './board-list.component.html',
  styleUrls: ['./board-list.component.scss']
})
export class BoardListComponent implements OnInit {
  page = 1;

  @Input() boardInfo: any = {};
  @Input() memberInfo: any = {};
  @Input() data: any = [];
  @Input() groupTab: any = [];
  @Input() params: any = {};
  @Input() authCheck$: BehaviorSubject<boolean>;

  public baseURL: any = config.baseUrl;
  public maxSize: any = 10;

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    public utilService: UtilService
  ) {
    if ( window.innerWidth <= 720 ) {
      this.maxSize = 3;
    }
  }

  /*******************************************************************************
    설  명 : 데이터 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit(): void {
  }

  /*******************************************************************************
    설  명 : 상세페이지로 이동
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  view( row: any ) {
    // AHRI 문의게시판, 특허/인증 기술행정 서비스문의
    if (this.boardInfo.board_type_code === '2000' || this.boardInfo.board_type_code === '2001') {
      const isAuth = (this.memberInfo.level >= 80 || this.memberInfo.level === '4'
        || this.memberInfo.memNo === row.writer) ? true : false;
      if (!isAuth) {
        this.toastrService.error( '문의 글은 관리자와 작성자만 확인 할 수 있습니다.' );
        return false;
      }
    }

    this.params.board_seq = row.board_seq;
    this.router.navigate(
    ['/board/view'],
    {
      relativeTo: this.activatedRoute,
      queryParams: this.params,
      queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

  /*******************************************************************************
    설  명 : 페이지 선택 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  loadPage( page ) {
    // 반드시 체크할 것
    // 페이지 리프리시 할때 권한 문제 발생
    this.authCheck$.subscribe( check => {
      if( check == false ) return false;

      this.params.no = page;

      this.router.navigate(
      [location.pathname],
      {
        relativeTo: this.activatedRoute,
        queryParams: this.params,
        queryParamsHandling: '', // remove to replace all query params by provided
      });
    });
  }

  /*******************************************************************************
    설  명 : 게시판 정보 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  checkLoading() {
    if( this.boardInfo === null ) return false;
    else if( typeof this.boardInfo['board_type_code'] === 'undefined' ) return false;
    else return true;
  }

  /*******************************************************************************
    설  명 : 전체 갯수 리턴
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getTotalCount() {
    if( this.checkLoading() ) return this.boardInfo.total_count | 0;
    else return 0;
  }

  /*******************************************************************************
    설  명 : 글쓰기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  write() {
    this.params.type = 'write';

    this.router.navigate(
      [location.pathname],
      {
        relativeTo: this.activatedRoute,
        queryParams: this.params,
        queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

  /*******************************************************************************
    설  명 : 페이지 리스트 새로고침
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  loadList( group_id ) {
    this.params.group_id = group_id;

    this.router.navigate(
    ['/board/list'],
    {
      relativeTo: this.activatedRoute,
      queryParams: this.params,
      queryParamsHandling: 'merge', // remove to replace all query params by provided
    });
  }

  /*******************************************************************************
    설  명 : 답변인지 검색
    입력값 : item
    리턴값 : 답변 : true / 일반 게시글 : false
  *******************************************************************************/
  checkReply( item: any ) {
    if( typeof item == 'undefined' ) return false;
    else if( typeof item.reply_level == 'undefined' ) return false;
    else if( item.reply_level == '0' ) return false;
    else if( item.board_index.substr(9, 2) !== '99') return true;
    else return false;
  }

  /*******************************************************************************
    설  명 : 답변 갯수만큼 배열 생성
    입력값 : cnt - 답변 레벨
    리턴값 : array
  *******************************************************************************/
  arrayReply( cnt ) {
    if( typeof cnt == 'undefined' ) return [];

    let tmp:any = [];
    for( let i = 0; i < cnt; i++ ) tmp.push(i);
    return tmp;
  }
}
